import { Geo } from '../../../providers/api/dtos';
import { isEmpty } from '../../../utils/object/object';
import { GEO_FORM_MODEL_DEFAULT_VALUES } from './constants';
import { GeoFormModel } from './types';

export const geoToGeoFormModel = (geo?: Geo): GeoFormModel => {
  if (!geo) return GEO_FORM_MODEL_DEFAULT_VALUES;

  return {
    administrativeAreaLevelOne: geo.administrativeAreaLevelOne || '',
    administrativeAreaLevelTwo: geo.administrativeAreaLevelTwo || '',
    locality: geo.locality || '',
    plateCode: geo.plateCode || '',
    postalCode: geo.postalCode || '',
    route: geo.route || '',
    streetNumber: geo.streetNumber || '',
    suburb: geo.suburb || '',
    normalizedAddress: geo.normalizedAddress ? {
      placeId: '',
      description: geo.normalizedAddress,
    } : null,
    latitude: geo.latitude ? `${geo.latitude}` : '',
    longitude: geo.longitude ? `${geo.longitude}` : '',
  };
};

export const geoFormModelToGeo = (geoFormModel: GeoFormModel): Geo | undefined => {
  const geo: Geo = {
    administrativeAreaLevelOne: geoFormModel.administrativeAreaLevelOne?.trim() || undefined,
    administrativeAreaLevelTwo: geoFormModel.administrativeAreaLevelTwo?.trim() || undefined,
    latitude: geoFormModel.latitude?.trim()
      ? Number(geoFormModel.latitude.trim())
      : undefined,
    longitude: geoFormModel.longitude?.trim()
      ? Number(geoFormModel.longitude.trim())
      : undefined,
    locality: geoFormModel.locality?.trim() || undefined,
    plateCode: geoFormModel.plateCode?.trim() || undefined,
    postalCode: geoFormModel.postalCode?.trim() || undefined,
    route: geoFormModel.route?.trim() || undefined,
    suburb: geoFormModel.suburb?.trim() || undefined,
    streetNumber: geoFormModel.streetNumber?.trim() || undefined,
    normalizedAddress: geoFormModel.normalizedAddress?.description?.trim() || undefined,
  };

  return isEmpty(geo) ? undefined : geo;
};
